<div class="flex">
  <p class="username m-r-md">{{ client?.fields?.nom_cli }}</p>
  <div class="user-profile"></div>
</div>
